import { IconCrossSmall } from 'central-icons/IconCrossSmall';
import classNames from 'classnames';
import type { ComponentPropsWithoutRef } from 'react';

import styles from './InputChip.module.css';

export type InputChipProps = Omit<
  ComponentPropsWithoutRef<'span'>,
  'children'
> & {
  label: string;
  onRemove?: () => void;
  disabled?: boolean;
  isInvalid?: boolean;
};

export function InputChip({
  label,
  onRemove,
  disabled,
  isInvalid,
  className,
  ...rest
}: InputChipProps) {
  return (
    <span
      {...rest}
      className={classNames(styles.chip, className)}
      data-disabled={disabled || undefined}
      data-invalid={isInvalid || undefined}
    >
      <span className={styles.chipLabel}>{label}</span>
      {!disabled && onRemove && (
        <button
          type="button"
          className={styles.chipRemove}
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          aria-label={`Remove ${label}`}
        >
          <IconCrossSmall size={12} />
        </button>
      )}
    </span>
  );
}
